// import EmailTemplateContainer from "./EmailTemplate";
// import EmailSetupContainer from "./EmailSetup";
// import SyncSetupContainer from "./SyncSetup";
// import EmailToDataContainer from "./EmailToData";
// import EmailToDataCreateNewContainer from "./EmailToData/CreateNew";
// import EmailTimelineContainer from "./EmailTimeline";
import React from 'react';

const EmailTemplateContainer = React.lazy(() => import('./EmailTemplate'));
const EmailSetupContainer = React.lazy(() => import('./EmailSetup'));
const SyncSetupContainer = React.lazy(() => import('./SyncSetup'));
const EmailToDataContainer = React.lazy(() => import('./EmailToData/index'));
const EmailToDataCreateNewContainer = React.lazy(() => import('./EmailToData/CreateNew'));
const EmailTimelineContainer = React.lazy(() => import('./EmailTimeline'));



export {
    EmailTemplateContainer,
    EmailSetupContainer,
    SyncSetupContainer,
    EmailToDataContainer,
    EmailToDataCreateNewContainer,
    EmailTimelineContainer
};
